<template>
  <div class="flex flex-col gap-3 p-3 rounded-lg border border-slate-200 dark:border-zinc-700 bg-slate-100 dark:bg-zinc-800">
    <p class="text-sm font-semibold max-w-[250px]">{{ text }}</p>
    <Button type="solid" variant="orange" :href="props.href" @click="$emit('click')">Upgrade to Create</Button>
  </div>
</template>
<script setup lang="ts">
import { Button } from './../../button';

interface Props {
  text: string;
  href?: string;
}

const props = defineProps<Props>();
</script>
